// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__beEOK","bannerTextContainer":"banner_bannerTextContainer__Rq9qY","bannerText":"banner_bannerText__dh9oU"};